// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2E67L","noInteraction":"EventWrapper_noInteraction__2TkBS"};